import React from 'react'

import { AmpStickyAd } from './AmpStickyAd'
import { createRegisterableComponent } from '@news-mono/web-common'
import { AdDefinition } from '@news-mono/web-common'

export type AmpStickyAdUnitRouteProps = { slot: AdDefinition }

export const AmpStickyAdUnitRegistration = createRegisterableComponent(
    'amp-sticky-ad-unit',
    (props: AmpStickyAdUnitRouteProps, services) => {
        return <AmpStickyAd adState={services.adState} unitId={props.slot.id} />
    },
)
